import { render, staticRenderFns } from "./project-history.vue?vue&type=template&id=6c144a20&scoped=true"
import script from "./project-history.vue?vue&type=script&lang=js"
export * from "./project-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c144a20",
  null
  
)

export default component.exports